/* eslint-disable global-require */
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import store from '@state/store';
import { refreshToken } from './authutils';
import NProgress from './nprogress';

Vue.use(VueAxios, axios);

Vue.axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;

Vue.axios.interceptors.request.use(
  (config) => {
    NProgress.start();
    const Auth = require('./auth').default;
    const token = localStorage.getItem(Auth.options.tokenDefaultName);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)

);

Vue.axios.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.fail();
    const status = error.response ? error.response.status : null;
    const Auth = require('./auth').default;
    const requestUrl = error.config && error.config.url ? error.config.url : '';
    const isLoginRequest = requestUrl.includes('adminLogin') || requestUrl.includes('userLogin');

    if (status === 401 && !isLoginRequest) {
      const storedRefreshToken = localStorage.getItem('refresh_token');
      const currentToken = localStorage.getItem(Auth.options.tokenDefaultName);
      const usedAuthHeader = error.config && error.config.headers ? error.config.headers.Authorization : '';
      const usedToken = usedAuthHeader ? usedAuthHeader.replace('Bearer ', '').trim() : null;

      // If token in localStorage was already refreshed (by another tab or concurrent call), retry immediately
      if (currentToken && usedToken && currentToken !== usedToken) {
        error.config.headers.Authorization = `Bearer ${currentToken}`;
        error.config.baseURL = undefined;
        return Vue.axios.request(error.config);
      }

      if (storedRefreshToken) {
        return refreshToken(store)
          .then(() => {
            const freshToken = localStorage.getItem(Auth.options.tokenDefaultName);
            if (freshToken) {
              error.config.headers.Authorization = `Bearer ${freshToken}`;
            }
            error.config.baseURL = undefined;
            return Vue.axios.request(error.config);
          })
          .catch((innerError) => {
            const innerStatus = innerError && innerError.response ? innerError.response.status : (innerError && innerError.status);
            if (innerStatus === 403 || innerStatus === 401) {
              Auth.options.logoutData.redirect = '/login';
              Auth.logout();
            }
            return Promise.reject(innerError);
          });
      }

      Auth.options.logoutData.redirect = '/login';
      Auth.logout();
      return Promise.reject(error.response || error);
    }
    return Promise.reject(error.response || error);
  }
);

export default Vue.axios;
